/* ── Panier latéral Senso (remplace le tiroir Dawn ; même API que celle attendue par product-form.js) ── */
class SdCartDrawer extends HTMLElement {
  connectedCallback(){
    if (this._init) return; this._init = true;
    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-cd-close]')) { e.preventDefault(); return this.close(); }
      const q = e.target.closest('[data-cd-qty]'); if (q) { const [line, qty] = q.dataset.cdQty.split(':').map(Number); return this.change(line, qty); }
      if (e.target.closest('[data-cd-code-rm]')) return this.discount('');
    });
    this.addEventListener('input', (e) => { const f = e.target.closest('[data-cd-code]'); if (f) f.querySelector('button').disabled = !e.target.value.trim(); });
    this.addEventListener('submit', (e) => { const f = e.target.closest('[data-cd-code]'); if (!f) return; e.preventDefault(); const c = f.code.value.trim(); if (c) this.discount(c.toUpperCase()); });
    document.addEventListener('keyup', (e) => { if (e.key === 'Escape' && this.classList.contains('active')) this.close(); });
    document.addEventListener('click', (e) => { if (e.target.closest('#cart-icon-bubble')) { e.preventDefault(); this.open(); } });
  }
  open(){ this.classList.add('active'); document.body.classList.add('sd-cd-open'); const p = this.querySelector('.sd-cd__panel'); if (p) setTimeout(() => p.focus({ preventScroll: true }), 60); }
  close(){ this.classList.remove('active'); document.body.classList.remove('sd-cd-open'); }
  setActiveElement(el){ this.activeElement = el; }
  getSectionsToRender(){ return [{ id: 'sd-cart-drawer' }, { id: 'cart-icon-bubble' }]; }
  paint(sections){
    if (!sections) return;
    const wasOpen = this.classList.contains('active');
    if (sections['sd-cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['sd-cart-drawer'], 'text/html');
      const fresh = doc.querySelector('cart-drawer');
      if (fresh) { this.innerHTML = fresh.innerHTML; this.classList.toggle('is-empty', fresh.classList.contains('is-empty')); }
    }
    if (sections['cart-icon-bubble']) {
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const b = document.getElementById('cart-icon-bubble'), src = doc.querySelector('.shopify-section');
      if (b && src) b.innerHTML = src.innerHTML;
    }
    if (wasOpen) this.classList.add('active');
  }
  renderContents(parsed){ this.paint(parsed.sections); this.open(); }
  async post(url, body){
    this.classList.add('is-busy');
    try {
      body.sections = this.getSectionsToRender().map((s) => s.id); body.sections_url = location.pathname;
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const j = await r.json();
      if (j.sections) this.paint(j.sections);
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sd-cart-drawer', cartData: j });
      return j;
    } finally { this.classList.remove('is-busy'); }
  }
  change(line, quantity){ return this.post((window.routes && routes.cart_change_url) || '/cart/change', { line: line, quantity: Math.max(0, quantity) }); }
  async discount(code){
    const j = await this.post((window.routes && routes.cart_update_url) || '/cart/update', { discount: code });
    if (!code) return j;
    const ok = (j && j.discount_codes || []).some((d) => d.applicable && String(d.code).toUpperCase() === code);
    if (!ok) {
      if (j && (j.discount_codes || []).length) await this.post((window.routes && routes.cart_update_url) || '/cart/update', { discount: '' });
      const f = this.querySelector('[data-cd-code]');
      if (f) { let m = this.querySelector('.sd-cd__err'); if (!m) { m = document.createElement('p'); m.className = 'sd-cd__err'; f.after(m); } m.textContent = 'Code invalide ou expiré'; }
    }
    return j;
  }
}
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', SdCartDrawer);

(function(){
  /* menu mobile */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-sd-burger]');
    if (b) { var m = document.getElementById('sd-mnav'); if (m) { m.classList.toggle('is-open'); b.setAttribute('aria-expanded', m.classList.contains('is-open')); } }
    var s = e.target.closest('[data-sd-sub]');
    if (s) { var n = s.nextElementSibling; if (n) n.classList.toggle('is-open'); }
    var more = e.target.closest('[data-sd-more]');
    if (more) { var sec = more.closest('.sd-cat'); var all = sec.classList.toggle('is-all');
      sec.querySelectorAll('[data-sd-more]').forEach(function(x){ x.textContent = all ? 'Réduire ↑' : x.dataset.label; }); }
  });
  /* WhatsApp : apparition après 1,2 s */
  setTimeout(function(){ var w = document.querySelector('.sd-wa'); if (w) w.classList.add('is-on'); }, 1200);
  /* fumée du hero */
  function smoke(){ document.querySelectorAll('[data-sd-smoke]').forEach(function(c){
    if (c.dataset.on) return; c.dataset.on = 1;
    if (window.sdSmoke) try { window.sdSmoke(c, parseFloat(c.dataset.intensity||0.18), parseFloat(c.dataset.ox||0.58), parseFloat(c.dataset.oy||0.7)); } catch(e){ console.warn(e); }
  }); }
  if (document.readyState !== 'loading') smoke(); else document.addEventListener('DOMContentLoaded', smoke);
  document.addEventListener('shopify:section:load', smoke);

  /* formulaires → Supabase (CRM Lovable) */
  document.addEventListener('submit', async function(e){
    var f = e.target.closest('form[data-sd-supabase]'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type=submit]'); var err = f.querySelector('.sd-form__err');
    var label = btn.textContent; btn.disabled = true; btn.textContent = btn.dataset.sending || 'Envoi…'; if (err) err.textContent = '';
    var fd = new FormData(f), row = {};
    fd.forEach(function(v,k){ v = String(v).trim(); if (k.charAt(0) !== '_') row[k] = v || null; });
    if (f.dataset.kind === 'contact') {
      row = { institut_id: f.dataset.institut, nom: row.nom, email: row.email, telephone: row.telephone, message: '[' + (row.objet || '') + '] ' + (row.message || ''), source: 'site_contact' };
    }
    try {
      var r = await fetch(f.dataset.url + '/rest/v1/' + f.dataset.sdSupabase, { method: 'POST', headers: { 'apikey': f.dataset.key, 'Authorization': 'Bearer ' + f.dataset.key, 'Content-Type': 'application/json', 'Prefer': 'return=minimal' }, body: JSON.stringify(row) });
      if (!r.ok) throw new Error((await r.text()).slice(0, 200) || r.status);
      var done = f.parentNode.querySelector('.sd-done'); if (done) { f.hidden = true; done.hidden = false; }
    } catch (x) { if (err) err.textContent = 'Erreur : ' + x.message; btn.disabled = false; btn.textContent = label; }
  });
})();

/* ── Fiche produit : variantes, galerie, quantité ── */
class SdProduct extends HTMLElement {
  connectedCallback(){
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.input = this.querySelector('input[name=id]');
    this.stage = this.querySelector('[data-stage]');
    this.addEventListener('click', (e) => {
      const v = e.target.closest('[data-variant]'); if (v) return this.pick(+v.dataset.variant);
      const t = e.target.closest('[data-thumb]'); if (t) return this.show(t);
      const q = e.target.closest('[data-qty]'); if (q) { const i = this.querySelector('input[name=quantity]'); i.value = Math.max(1, (+i.value || 1) + (+q.dataset.qty)); }
    });
  }
  show(t){ this.stage.src = t.dataset.src; this.querySelectorAll('[data-thumb]').forEach(x => x.classList.toggle('is-on', x === t)); }
  pick(id){
    const v = this.variants.find(x => x.id === id); if (!v) return;
    this.input.value = v.id;
    this.querySelectorAll('[data-variant]').forEach(b => b.classList.toggle('is-on', +b.dataset.variant === id));
    const fmt = (c) => (c / 100).toFixed(2) + ' €';
    this.querySelector('[data-price]').textContent = fmt(v.price);
    const cmp = this.querySelector('[data-compare]');
    if (v.compare_at_price && v.compare_at_price > v.price) { cmp.textContent = fmt(v.compare_at_price); cmp.hidden = false; } else cmp.hidden = true;
    const btn = this.querySelector('.sd-atc'), txt = btn.querySelector('span');
    if (v.available) { btn.removeAttribute('disabled'); txt.textContent = btn.dataset.add; } else { btn.setAttribute('disabled', ''); txt.textContent = btn.dataset.soldout; }
    if (v.featured_image) {
      const src = v.featured_image.src + (v.featured_image.src.includes('?') ? '&' : '?') + 'width=1200';
      this.stage.src = src;
      const first = this.querySelector('[data-thumb]'); if (first) { first.dataset.src = src; first.querySelector('img').src = src; this.show(first); }
    }
    const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
  }
}
if (!customElements.get('sd-product')) customElements.define('sd-product', SdProduct);

/* ── Composeur de pack ── */
class SdPack extends HTMLElement {
  connectedCallback(){
    this.cfg = JSON.parse(this.querySelector('[data-pack]').textContent);
    // Force la limite maximale totale à 10 articles
    this.cfg.count = Math.min(this.cfg.count || 10, 10);
    this.sel = [];
    this.box = this.querySelector('[data-props]');
    this.addEventListener('click', (e) => {
      const b = e.target.closest('[data-inc],[data-dec]'); if (!b || b.disabled) return;
      const key = b.dataset.inc || b.dataset.dec, [slug, variant] = key.split('::');
      if (b.dataset.inc) this.inc(slug, variant || null); else this.dec(slug, variant || null);
      this.render();
    });
    this.render();
  }
  ml(v){ if (!v) return null; const s = v.toLowerCase().replace(/\s+/g, ''); let m = s.match(/^(\d+(?:[.,]\d+)?)ml$/); if (m) return Math.round(parseFloat(m[1].replace(',', '.')));
    m = s.match(/^(\d+(?:[.,]\d+)?)l$/); if (m) return Math.round(parseFloat(m[1].replace(',', '.')) * 1000); return null; }
  get volume(){ 
    const formats = Array.isArray(this.cfg.formats) ? this.cfg.formats : [];
    return formats.filter(f => this.ml(f) !== null).length >= 2; 
  }
  get target(){ 
    const formats = Array.isArray(this.cfg.formats) ? this.cfg.formats : [];
    return this.volume ? this.cfg.count * Math.max(...formats.map(f => this.ml(f) || 0)) : 0; 
  }
  get current(){ return this.sel.reduce((s, x) => s + (this.ml(x.variant) || 0), 0); }
  inc(slug, variant){
    if (this.sel.length >= 10) return; // Limitation stricte à 10 au total
    if (this.volume) { const m = this.ml(variant) || 0; if (!m || this.current + m > this.target) return; }
    else if (this.sel.length >= this.cfg.count) return;
    this.sel.push({ slug, variant });
  }
  dec(slug, variant){ for (let i = this.sel.length - 1; i >= 0; i--) if (this.sel[i].slug === slug && (this.sel[i].variant || null) === (variant || null)) { this.sel.splice(i, 1); return; } }
  fmtL(ml){ return ml >= 1000 ? (ml / 1000).toString().replace('.', ',') + ' L' : ml + ' ml'; }
  render(){
    const c = this.cfg, vol = this.volume, full = this.sel.length >= c.count, rem = this.target - this.current;
    this.querySelectorAll('[data-count]').forEach(el => {
      const k = el.dataset.count, [slug, variant] = k.split('::');
      el.textContent = this.sel.filter(x => x.slug === slug && (!variant || x.variant === variant)).length;
    });
    this.querySelectorAll('[data-row]').forEach(r => r.classList.toggle('is-on', this.sel.some(x => x.slug === r.dataset.row)));
    this.querySelectorAll('[data-dec]').forEach(b => { const [slug, variant] = b.dataset.dec.split('::'); const n = this.sel.filter(x => x.slug === slug && (!variant || x.variant === variant)).length; b.disabled = n === 0; });
    this.querySelectorAll('[data-inc]').forEach(b => { const [slug, variant] = b.dataset.inc.split('::');
      const n = this.sel.filter(x => x.slug === slug && (!variant || x.variant === variant)).length; b.classList.toggle('is-on', n > 0);
      b.disabled = this.sel.length >= 10 || (vol ? rem < (this.ml(variant) || 1e9) : full); });
    const h = this.querySelector('[data-head]');
    if (h && c.choice) h.innerHTML = vol ? ('Composez votre pack — ' + this.fmtL(this.current) + ' / ' + this.fmtL(this.target) + (rem > 0 ? '<small>(reste ' + this.fmtL(rem) + ')</small>': ''))
                                    : ('Choisissez ' + c.count + ' ' + c.noun + (c.count > 1 ? 's' : '') + ' (' + this.sel.length + '/' + c.count + ')');
    const ok = !c.choice || (vol ? (this.current === this.target && this.target > 0) : this.sel.length === c.count);
    const btn = this.querySelector('.sd-atc'), txt = btn.querySelector('span');
    btn.setAttribute('aria-disabled', ok ? 'false' : 'true'); if (ok) btn.removeAttribute('aria-disabled');
    else btn.setAttribute('aria-disabled', 'true');
    txt.textContent = ok ? 'Ajouter au panier' : (vol ? ('Encore ' + rem + ' ml à ajouter') : ('Sélectionnez ' + (c.count - this.sel.length) + ' de plus'));
    const formats = Array.isArray(c.formats) ? c.formats : [];
    const suffix = (formats.length && !vol) ? ' (' + formats.join(' / ') + ')' : (c.variant_label ? ' (' + c.variant_label + ')' : '');
    const names = c.choice ? this.sel.map(s => { const p = c.items[s.slug]; const n = p ? p.title : s.slug; return vol && s.variant ? n + ' — ' + s.variant : n + suffix; })
                           : Object.values(c.items).map(p => p.title + suffix);
    this.box.innerHTML = names.map((n, i) => `<input type="hidden" name="properties[Produit ${i + 1}]" value="${n.replace(/"/g, '&quot;')}">`).join('');
  }
}
if (!customElements.get('sd-pack')) customElements.define('sd-pack', SdPack);